import Vue from 'vue';
import Icon from '@/components/global/Icon/Icon.vue';

export const registerGlobalComponents = () => {
  Vue.component('icon', Icon);
};
